import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft, Shield } from "lucide-react";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <div className="relative min-h-screen hero-radial grain">
      <header className="relative z-30 flex items-center justify-between px-6 sm:px-10 py-5">
        <Link to="/" className="flex items-center gap-2 text-stone-300 hover:text-amber-200" data-testid="back-home">
          <ChevronLeft className="w-4 h-4" /> {t("common.back_home")}
        </Link>
        <div className="flex items-center gap-2 font-serif text-lg">
          <Shield className="w-5 h-5 text-emerald-300" /> {t("legal.privacy_title")}
        </div>
        <LanguageSwitcher />
      </header>
      <main className="relative z-10 max-w-3xl mx-auto px-6 sm:px-10 pb-20 space-y-6 text-stone-200" data-testid="privacy-content">
        <h1 className="font-serif text-4xl font-black text-stone-50">{t("legal.privacy_title")}</h1>
        <p className="text-xs uppercase tracking-widest text-amber-300 font-bold">{t("legal.updated_on")} 2026-03-02</p>
        <p className="italic text-stone-300">{t("legal.privacy_intro")}</p>

        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.privacy_collected_h")}</h2>
          <p>{t("legal.privacy_collected_p")}</p>
          <ul className="list-disc pl-6 space-y-1 text-stone-300">
            <li>{t("legal.privacy_collected_1")}</li>
            <li>{t("legal.privacy_collected_2")}</li>
            <li>{t("legal.privacy_collected_3")}</li>
            <li>{t("legal.privacy_collected_4")}</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.privacy_kids_h")}</h2>
          <p>{t("legal.privacy_kids_p")}</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.privacy_ai_h")}</h2>
          <p>{t("legal.privacy_ai_p")}</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.privacy_rights_h")}</h2>
          <p>{t("legal.privacy_rights_p")}</p>
          <p>{t("legal.privacy_contact")} <a href="mailto:privacy@chronostimepuzzle.com" className="text-amber-300 hover:text-amber-200 underline" data-testid="privacy-email">privacy@chronostimepuzzle.com</a></p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.privacy_third_h")}</h2>
          <ul className="list-disc pl-6 space-y-1 text-stone-300">
            <li>{t("legal.privacy_third_stripe")}</li>
            <li>{t("legal.privacy_third_emergent")}</li>
            <li>{t("legal.privacy_third_resend")}</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.privacy_retention_h")}</h2>
          <p>{t("legal.privacy_retention_p")}</p>
        </section>
      </main>
    </div>
  );
}
